import React from 'react';
import { getColor } from '@panel/commons/core/themev3';
import { select } from '@panel/commons/core/themev2';
import styled from 'styled-components';

const OptionInput = ({
  type,
  name,
  value,
  selected = false,
  onChange,
  label,
  hasCheckIcon = false,
  flexWidth = false,
  padding = '0 16px',
  dataPubli = ''
}) => {
  return (
    <OptionContainer
      data-publi={name.concat('-', value)}
      selected={selected}
      hasCheckIcon={hasCheckIcon}
      flexWidth={flexWidth}
      padding={padding}
    >
      <input type={type} name={name} value={value} onChange={onChange} data-publi={dataPubli} />
      <span>{label}</span>
    </OptionContainer>
  );
};

const OptionContainer = styled.label`
  height: 40px;
  display: flex;
  flex-grow: ${({ flexWidth }) => (flexWidth ? 1 : 0)};
  align-items: center;
  justify-content: ${({ hasCheckIcon }) => (hasCheckIcon ? 'space-between' : 'center')};
  padding: ${({ padding }) => padding};
  border-radius: 8px;
  border: 1px solid ${({ selected }) => (selected ? getColor('primary') : select('midDarkGrayAux'))};
  background-color: ${({ selected }) => (selected ? getColor('tertiary') : 'transparent')};
  cursor: pointer;
  transition: background-color 0.2s ease, border-color 0.2s ease;

  &:hover {
    background-color: ${({ selected }) => (!selected ? select('neutralGray') : 'none')};
  }

  input {
    display: none;
  }

  span {
    font-family: Hind;
    font-weight: 500;
    font-size: 14px;
    line-height: 24px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .check-icon {
    text-align: right;
  }
`;

export default OptionInput;
